export enum ReportEvaluationStateValidation 
{
    HayPendientes = 0,
    TodasAprobados = 1, 
    HayNoAprobados = 2,
    NoHayEvaluaciones = 3
}